import { styled } from "@mui/material/styles";
import { Stack, Typography, Box, useTheme, useMediaQuery } from "@mui/material";
import Containter from "components/Containter";
import { ReactNode } from "react";
import { Medium, Telegram, Twitter, Discord, Logo } from "components/Svg";
import Grid from "@mui/material/Unstable_Grid2";
import { NavLink } from "react-router-dom";

const Footer1Box = styled(Stack)`
  background: #1a1a1a;
`;

const Footer1Title = styled(Typography)`
  color: #fff;
  font-size: 14px;
  font-style: normal;
  font-weight: 400;
  line-height: normal;
  ${({ theme }) => ({
    [theme.breakpoints.down("md")]: {
      fontSize: "14px",
    },
  })};
`;

const Footer1Info = styled(Typography)<{ isComing: boolean; desc?: string }>`
  color: rgba(255, 255, 255, 0.6);
  font-size: 14px;
  font-style: normal;
  font-weight: 400;
  line-height: normal;
  position: relative;
  cursor: pointer;
  &:hover {
    color: ${({ isComing }) =>
      isComing ? "rgba(255, 255, 255, 0.6)" : "#fff"};
  }
  &::after {
    display: ${({ isComing }) => (isComing ? "block" : "none")};
    position: absolute;
    content: "Stay Tuned";
    font-size: 8px;
    color: #999;
    background: #3c3c3c;
    border-radius: 21px;
    padding: 3px 5px;
    top: 3px;
    right: -60px;
  }
  ${({ theme }) => ({
    [theme.breakpoints.down("md")]: {
      fontSize: "14px",
    },
  })};
`;

const Footer2Text = styled(Typography)`
  color: rgba(255, 255, 255, 0.6);
  font-size: 14px;
  font-style: normal;
  font-weight: 400;
  line-height: normal;
`;

const GridLogoWhite = styled(Grid)`
  ${({ theme }) => ({
    [theme.breakpoints.down("md")]: {
      // display: "none",
      marginBottom: "20px",
    },
  })};
`;

const Footer1Desc = styled("a")`
  color: #fff;
  font-size: 16px;
  font-style: normal;
  font-weight: 100;
  line-height: normal;
  text-decoration-line: underline;
  margin-left: 3px;
  font-family: KindSansRegular;
`;

const Footer1Item = styled(Stack)`
  .fill-color {
    fill: rgba(255, 255, 255, 0.6);
  }
  &:hover {
    .fill-color {
      fill: #fff;
    }
  }
`;

const FooterLinkBox = styled(Grid)`
  border-left: 1px solid #2c2c2c;
  padding-left: 70px;
  ${({ theme }) => ({
    [theme.breakpoints.down("md")]: {
      borderLeft: "none",
      paddingLeft: "8px",
    },
  })};
`;

interface subConItem {
  name: string;
  path: string;
  icon?: ReactNode;
  isComing?: boolean;
  target?: string;
  desc?: string;
}

interface FooterItem {
  name: string;
  subCon: subConItem[];
}

const Footer = () => {
  const theme = useTheme();
  const downToMd = useMediaQuery(theme.breakpoints.down("md"));
  const goTop = () => {
    document.body.scrollTop = 0;
  };
  const footerData: FooterItem[] = [
    {
      name: "Quick Links",
      subCon: [
        {
          name: "Buy USD0x",
          path: "",
          target: "_blank",
          isComing: true,
        },
        {
          name: "Campaign",
          path: "",
          target: "_blank",
          isComing: true,
        },
        {
          name: "Docs",
          path: "https://docs.usd0x.money",
          target: "_blank",
          isComing: false,
        },
      ],
    },
    {
      name: "Statement",
      subCon: [
        {
          name: "Privacy Policy",
          path: "/pdf/privacy-policy.pdf",
          target: "_blank",
        },
        {
          name: "Terms of Service",
          path: "/pdf/terms-service.pdf",
          target: "_blank",
        },
      ],
    },
  ];
  return (
    <Box>
      <Footer1Box>
        <Containter>
          <Stack py={downToMd ? 30 : 60}>
            <Grid container spacing={10}>
              <GridLogoWhite xs={12} md={4}>
                <Stack
                  justifyContent="space-between"
                  alignItems="flex-start"
                  direction="column"
                  height={"100%"}
                >
                  <Box>
                    <Logo />
                    <Footer2Text mt={12}>Super Collateral for Everyone</Footer2Text>
                  </Box>
                  {!downToMd && (
                    <Footer2Text>
                      © 2025 Stables Labs. All rights reserved.
                    </Footer2Text>
                  )}
                </Stack>
              </GridLogoWhite>
              {footerData.map((d: FooterItem, index: number) => (
                <>
                  <FooterLinkBox xs={6} md={4}>
                    <Box mb={20}>
                      <Footer1Title>{d.name}</Footer1Title>
                    </Box>
                    {d.subCon.map((subItem: subConItem) => (
                      <>
                        {subItem?.isComing ? (
                          <>
                            <Footer1Item
                              justifyContent="start"
                              alignItems="center"
                              direction="row"
                              mt={15}
                            >
                              <Footer1Info
                                isComing={subItem?.isComing || false}
                                desc={subItem?.desc || ""}
                              >
                                {subItem.name}
                              </Footer1Info>
                            </Footer1Item>
                          </>
                        ) : (
                          <NavLink
                            onClick={() => {
                              !subItem.desc && goTop();
                            }}
                            to={subItem.path}
                            target={subItem?.target || ""}
                          >
                            <Footer1Item
                              justifyContent="start"
                              alignItems="center"
                              direction="row"
                              mt={15}
                            >
                              {subItem?.icon && (
                                <Box mr={10}>{subItem?.icon}</Box>
                              )}
                              <Box>
                                <Footer1Info
                                  isComing={subItem?.isComing || false}
                                >
                                  {subItem.name}
                                  {subItem.desc && (
                                    <Footer1Desc
                                      target="_blank"
                                      href={subItem.path}
                                    >
                                      {subItem.desc}
                                    </Footer1Desc>
                                  )}
                                </Footer1Info>
                              </Box>
                            </Footer1Item>
                          </NavLink>
                        )}
                      </>
                    ))}
                  </FooterLinkBox>
                </>
              ))}
            </Grid>
            {downToMd && (
              <Footer2Text mt={30}>
                © 2025 Stables Labs. All rights reserved.
              </Footer2Text>
            )}
          </Stack>
        </Containter>
      </Footer1Box>
      {/* <Footer2Box
        justifyContent="center"
        alignItems="center"
        direction="row"
        py={15}
      >
        <Footer2Text>© 2024 usdx.money all rights reserved.</Footer2Text>
      </Footer2Box> */}
    </Box>
  );
};

export default Footer;
